





















import Button from '@/components/common/button.vue';
import { disableBodyScroll, enableBodyScroll } from '@/utils/page-scroll';
import { defineComponent, watch, computed } from '@vue/composition-api';
export default defineComponent({
  name: 'NewUserDialog',
	  components: { Button },
  props: {
    isShowNewUserDialog: {
      type: Boolean,
      isRequired: true,
    },
    goExchange: {
      type: Function,
      isRequired: true,
    },
  },

  setup(props) {
    watch(props, () => {
      if (props.isShowNewUserDialog) {
        disableBodyScroll();
      } else {
        enableBodyScroll();
      }
    });

    const isNormalVer = computed(() => new Date() > new Date('2023/01/01 00:00:00') || /normal/.test(location.href));
    return { isNormalVer };
  },
});
